// extracted by mini-css-extract-plugin
export default {"container":"AddRecordsWizard_container__o-X69"};